import script from "./BecomePartner.vue?vue&type=script&setup=true&lang=js"
export * from "./BecomePartner.vue?vue&type=script&setup=true&lang=js"

import "./BecomePartner.vue?vue&type=style&index=0&id=f36b594e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f36b594e"]])

export default __exports__